import api from 'api';

export const MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const MAIN_COLOR_DESIGN_TEMPLATES_RESET_STATE = 'MAIN_COLOR_DESIGN_TEMPLATES_RESET_STATE';

function mainColorDesignTemplatesAsyncActionStart() {
  return {
    type: MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function mainColorDesignTemplatesAsyncActionError(error) {
  return {
    type: MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function mainColorDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetmainColorDesignTemplatesState() {
  return {
    type: MAIN_COLOR_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getmainColorDesignTemplates(designTypeId, designSizeId, businessTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(mainColorDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?designtid=${ designTypeId }&sizeid=${ designSizeId }&typeId=${ businessTypeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(mainColorDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(mainColorDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function getmainColorThemeDesignTemplates(businessTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(mainColorDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?typeId=${ businessTypeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(mainColorDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(mainColorDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}
